import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCheckCircleDashed: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="check-circle-dashed, done, confirm, save, success"><path d="M15 9.5L10.5 15L8.5 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M21.25 12C21.25 17.1086 17.1086 21.25 12 21.25C6.89137 21.25 2.75 17.1086 2.75 12C2.75 6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round" strokeDasharray="3 4"/></CentralIconBase>;
};

export default IconCheckCircleDashed;
